import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

// Pages & Layouts
import DashboardPage from "./pages/Dashboard/DashboardPage";
import ProfilePage from "./pages/Profile/ProfilePage";
import GamesPage from "./pages/Games/GamesPage";
import AuthPage from "./pages/Auth/AuthPage";
import DiscordAuthHandler from "./pages/Auth/DiscordAuthHandler";
import OnboardingPage from "./pages/Onboarding/OnboardingPage";
import ClanManagePage from "./pages/Clan/ClanManagePage";
import PublicLayout from "./layout/PublicLayout/PublicLayout";
import ProtectedLayout from "./layout/ProtectedLayout/ProtectedLayout";
import LoadingPage from "./pages/LoadingPage/LoadingPage";

// Components
import GameDetail from "./components/Games/GameDetail/GameDetail";
import AuthenticatedSpectatePage from "./components/Games/SpectateGamesDashboard/AuthenticatedSpectatePage";
import SpectateGamesDashboard from "./components/Games/SpectateGamesDashboard/SpectateGamesDashboard";
import SpectateGameDetail from "./components/Games/GameDetail/SpectateGameDetail";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import PlatformWalkthrough from "./pages/PlatformWalkthrough/PlatformWalkthrough";
import GuideRouterWrapper from "./pages/PlatformWalkthrough/GuideRouterWrapper";

const AUTH_GAME_DETAIL_PATH =
  "/games/clan/:clanId/events/:eventId/game/:gameId";
const PUBLIC_GAME_DETAIL_PATH = "/games/spectate/:gameId";

function App() {
  return (
    <>
      <Routes>
        {/* Protected Routes */}
        <Route element={<ProtectedLayout />}>
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/games" element={<GamesPage />}>
            <Route
              path="spectate-auth"
              element={<AuthenticatedSpectatePage />}
            />
          </Route>
          <Route path={AUTH_GAME_DETAIL_PATH} element={<GameDetail />} />
          <Route path="/clans/manage/:clanId" element={<ClanManagePage />} />

          {/* Guide nested in ProtectedLayout */}
          <Route path="/dashboard/guide" element={<PlatformWalkthrough />} />
        </Route>

        {/* Public Routes */}
        <Route element={<PublicLayout />}>
          <Route path="/" element={<AuthPage />} />
          <Route path="/auth-callback" element={<DiscordAuthHandler />} />
          <Route path="/loading" element={<LoadingPage />} />
          <Route path="/onboarding" element={<OnboardingPage />} />
          <Route path="/games/spectate" element={<SpectateGamesDashboard />} />
          <Route
            path={PUBLIC_GAME_DETAIL_PATH}
            element={<SpectateGameDetail />}
          />

          {/* Guide nested in PublicLayout */}
          <Route path="/public/guide" element={<PlatformWalkthrough />} />
        </Route>

        {/* Traffic Controller for the /guide link */}
        <Route path="/guide" element={<GuideRouterWrapper />} />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <ScrollToTop />
    </>
  );
}

export default App;
